module.exports = __webpack_public_path__ + "img/9.37982300.jpg";